import {get} from './http';
import {type Report, type ReportQuery} from './reporting';

/**
 The Submissions dashboard's data, from the API itself (it used to be a report of the reporting
 service). It comes back in the report shape, so the same blocks and filter controls draw it. The
 browser only sends named filters; the SQL stays server-side.
 */
export const submissionsDashboardApi = {
  async get(parameters?: ReportQuery) {
    return get<Report>('/dashboard/submissions', parameters);
  }
};
